import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const serviceName = "traffic-fine-service";
const endPoint = "settings";


export const UpdateFineSettings = createAsyncThunk("fineType/updateFineSettings", async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/${endPoint}/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});


export const getFineSettingsById = createAsyncThunk("fineType/getFineSettignsById", async ({ dispatch, getState }) => {

    const response = await apiInstance.get(`${serviceName}/v1/${endPoint}/1`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
})